import { combineReducers } from "redux";
import process, { ProcessReducer } from "./Process";
import header, { HeaderReducer } from "./Header";
import { DepartmentReducer, departmentReducer } from './department/departmentReducer';
import helpdesk, { HDReducer } from "./Helpdesk";
import { EmployeeInfo } from './EmployeeInfo';
import employee from "./EmployeeInfo";



export interface StateReducer {
    header: HeaderReducer;
    process: ProcessReducer;
    departmentReducer: DepartmentReducer;
    helpdesk: HDReducer;
    employee: EmployeeInfo;
}

export default combineReducers({
    header,
    process,
    helpdesk,
    employee,

    departmentReducer,
});